<template>
    <div
        :class="[
            'auth-layout',
            {
                'login-page': isLoginPage,
                'register-page': isRegisterPage,
            },
        ]"
    >
        <AuthHeader />

        <main class="auth-layout__content">
            <router-view />
        </main>

        <AuthFooter />
    </div>
</template>

<script lang="ts" setup>
    import { useRoute } from 'vue-router';
    import AuthHeader from '@/layouts/AuthLayout/components/AuthHeader.vue';
    import AuthFooter from '@/layouts/AuthLayout/components/AuthFooter.vue';

    const route = useRoute();

    const isLoginPage = route.name === 'Login';
    const isRegisterPage = route.name === 'Register';
</script>

<style lang="scss">
    @use './AuthLayout.scss' as *;
</style>
